import React from 'react';

export const NewYorkInfo = () => (
    <div>
        <p className="eds-text-bl eds-l-mar-bot-4">New York City</p>

        <p className="eds-l-mar-bot-1">
            <strong>Small Business Continuity Loan Fund</strong> |&nbsp;
            <a
                href="https://www1.nyc.gov/site/sbs/businesses/covid19-business-financial-assistance.page"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Businesses with fewer than 100 employees who have seen sales
            decreases of 25% or more will be eligible for zero interest loans of
            up to $75,000 to help retain employees and ensure business
            continuity.
        </p>

        <p className="eds-l-mar-bot-1 eds-l-mar-top-4">
            <strong>Employee Retention Grant Program</strong> |&nbsp;
            <a
                href="https://www1.nyc.gov/site/sbs/businesses/covid19-business-financial-assistance.page"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            The City is offering small businesses with fewer than 5 employees a
            grant to cover 40% of payroll costs for two months to help retain
            employees.
        </p>

        <p className="eds-text-bl eds-l-mar-bot-4 eds-l-mar-top-8">
            City of Syracuse
        </p>
        <p className="eds-l-mar-bot-1">
            <strong>Emergency Relief Program</strong> |&nbsp;
            <a
                href="http://www.syrgov.net/SEDCO_Home.aspx"
                target="_blank"
                rel="noopener noreferrer"
                className="eds-text-weight--heavy"
            >
                Apply
            </a>
        </p>
        <p>
            Up to $25,000 loans per business, average loan size is anticipated
            to be around $10,000 starting March 23, 2020.
        </p>
    </div>
);
